import { api } from '../api';

/**
 * Relatórios — o caderno de laudos e o quadro resumo (onda 214).
 *
 * O caminho de cada chamada fica escrito aqui, como nos outros arquivos de
 * `api/`: é o contrato entre a tela e o `relatorios.controller.ts`.
 */

export type TipoCaderno = 'amostra' | 'ensaio' | 'total';
export type FormatoQuadro = 'vertical' | 'horizontal' | 'sanepar';

export interface OsDoRelatorio {
  id: string; numero: string; cliente: string | null;
  obra_codigo: string | null; obra_nome: string | null;
  municipio: string | null; uf: string | null;
  ensaios_total: number | null; ensaios_aprovados: number | null;
}

export interface AmostraDoRelatorio {
  id: string; codigo: string; identificacao_recebida: string | null;
  ensaios: number; aprovados: number; emitidos: number;
}

export interface MetodoDoRelatorio {
  id: string; codigo: string; nome: string;
  amostras: number; ensaios: number; aprovados: number; emitidos: number;
}

export interface Panorama {
  os: OsDoRelatorio;
  amostras: AmostraDoRelatorio[];
  metodos: MetodoDoRelatorio[];
}

export interface ItemDoCaderno {
  ensaioId: string; amostraCodigo: string; identificacao: string | null;
  metodoCodigo: string; metodoNome: string; status: string;
  numero: string | null; revisao: number | null;
  situacao: 'emitido' | 'preliminar' | 'fora';
  motivo: string | null; mesmoLaudoDe?: string;
}

export interface PlanoDoCaderno {
  recorte: string;
  entram: ItemDoCaderno[];
  fora: ItemDoCaderno[];
}

export interface CelulaDoQuadro { num?: number; texto?: string; casas?: number }

export interface LinhaDoQuadro {
  grupo: string; metodo: string; parametro: string; rotulo: string;
  unidade: string | null; casas: number;
  celulas: Record<string, CelulaDoQuadro>;
}

export interface Quadro {
  legenda: string[];
  amostras: { id: string; codigo: string; identificacao: string | null }[];
  linhas: LinhaDoQuadro[];
}

export interface EscolhaDoCaderno {
  tipo: TipoCaderno;
  amostra?: string | null;
  metodo?: string | null;
  preliminares: boolean;
}

export const consultaDoCaderno = (e: EscolhaDoCaderno): string => {
  const q = new URLSearchParams({ tipo: e.tipo });
  if (e.tipo === 'amostra' && e.amostra) q.set('amostra', e.amostra);
  if (e.tipo === 'ensaio' && e.metodo) q.set('metodo', e.metodo);
  if (e.preliminares) q.set('preliminares', '1');
  return q.toString();
};

export const verPanorama = (osId: string) =>
  api<Panorama>(`/relatorios/os/${osId}`);

export const verPlanoDoCaderno = (osId: string, e: EscolhaDoCaderno) =>
  api<PlanoDoCaderno>(`/relatorios/os/${osId}/caderno?${consultaDoCaderno(e)}`);

export const caminhoDoCaderno = (osId: string, e: EscolhaDoCaderno) =>
  `/relatorios/os/${osId}/caderno.pdf?${consultaDoCaderno(e)}`;

export const verQuadro = (osId: string) =>
  api<Quadro>(`/relatorios/os/${osId}/quadro`);

export const caminhoDoQuadro = (osId: string, formato: FormatoQuadro) =>
  `/relatorios/os/${osId}/quadro.xlsx?formato=${formato}`;
